import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { siteSettingsApi } from '@/services';

export const siteSettingsKeys = {
  all: ['site-settings'] as const,
};

export function useSiteSettingsQuery() {
  return useQuery({
    queryKey: siteSettingsKeys.all,
    queryFn: () => siteSettingsApi.getAll(),
  });
}

export function useUpdateSiteSettingMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ key, value }: { key: string; value: unknown }) => siteSettingsApi.update(key, value),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: siteSettingsKeys.all });
    },
  });
}
